import type { GatsbyBrowser } from "gatsby";
import "./src/styles/fonts.css";
import "./src/styles/icons.css";
import "./src/styles/global.css";
import "./src/styles/blog.css";
import "react-phone-input-2/lib/style.css";
import "./src/styles/phoneStyles.css";
import 'rc-slider/assets/index.css';
import "./src/styles/rsSliderStyles.css";
import "./src/styles/map.css";
import 'react-calendar/dist/Calendar.css';
import "./src/styles/calendar.css";

// Swiper
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

interface LocationState {
  preserveScroll?: boolean;
}

export const onRouteUpdate = ({
  location,
  } : {
  location: { state: LocationState };
}) => {
  if (window.location.href.includes("#") || location.state?.preserveScroll) {
    return;
  }

  window.scrollTo({ top: 0, behavior: "instant" });
};

export const shouldUpdateScroll = ({ routerProps: { location } }: {routerProps: {location: {state: LocationState}}}) => {
  return !location.state?.preserveScroll;
};
